export const toDateSafe = (v) => {
  try {
    if (!v) return null;
    if (typeof v.toDate === 'function') return v.toDate();
    if (typeof v === 'number') return new Date(v);
    const d = new Date(String(v));
    return isNaN(d.getTime()) ? null : d;
  } catch {
    return null;
  }
};

export const formatDateTime = (v, options = { year: 'numeric', month: 'short', day: 'numeric' }) => {
  const d = toDateSafe(v);
  if (!d) return '';
  try {
    return d.toLocaleDateString(undefined, options);
  } catch {
    return d.toISOString().slice(0, 10);
  }
};

export const timeAgo = (v) => {
  const d = toDateSafe(v);
  if (!d) return '';
  const diff = Math.max(0, Date.now() - d.getTime());
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  return `${day}d ago`;
};

/**
 * Get date group label for notifications
 */
export const getDateGroup = (v) => {
  const d = toDateSafe(v);
  if (!d) return 'Unknown';

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const weekAgo = new Date(today);
  weekAgo.setDate(weekAgo.getDate() - 7);
  const monthAgo = new Date(today);
  monthAgo.setDate(monthAgo.getDate() - 30);

  if (d >= today) return 'Today';
  if (d >= yesterday) return 'Yesterday';
  if (d >= weekAgo) return 'This Week';
  if (d >= monthAgo) return 'This Month';
  return 'Older';
};

export const isToday = (v) => getDateGroup(v) === 'Today';
export const isYesterday = (v) => getDateGroup(v) === 'Yesterday';

/**
 * Format timestamp for chat session headers (Messenger-style)
 * - Today: Show time only (e.g., "2:30 PM")
 * - Yesterday: Show "Yesterday" + time
 * - This week: Show day name + time (e.g., "Mon 2:30 PM")
 * - Older: Show full date + time
 */
export const formatChatSessionTime = (v) => {
  const d = toDateSafe(v);
  if (!d) return '';
  
  const now = new Date();
  const isToday = d.toDateString() === now.toDateString();
  
  if (isToday) {
    return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  }
  
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) {
    return `Yesterday ${d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`;
  }
  
  const weekAgo = new Date(now);
  weekAgo.setDate(weekAgo.getDate() - 7);
  if (d > weekAgo) {
    return d.toLocaleTimeString([], { weekday: 'short', hour: 'numeric', minute: '2-digit' });
  }
  
  return d.toLocaleTimeString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
};

/**
 * Format timestamp for individual chat messages
 * Shows time only (e.g., "2:30 PM")
 */
export const formatChatMessageTime = (v) => {
  const d = toDateSafe(v);
  if (!d) return '';
  return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
};
